import _BaseController from 'Controllers/Web/_BaseController';

global.Controller = new (class extends _BaseController {
  ready() {
    super.ready();
  }
})();
